import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../../Helpers";
import {deserializePatient, Patient} from "../../../Patient";
import {deserializePhysician, Physician} from "../../../Physician";
import {deserializePatientTrigger, deserializeSurveyTrigger, PatientTrigger, SurveyTrigger as PatientSurveyTrigger} from "../../../Trigger";
import {deserializePatientTriggerEvent, PatientTriggerEvent} from "../../../trigger/PatientTriggerEvent";
import {deserializePatientSurveySession, PatientSurveySession} from "../Session";
import {SurveyCategory} from "vendor/qurasoft/definitions/types/surveys";

export interface PatientSurveyTriggerEvent extends DeserializedRecord{
  patient: Patient;
  physician: Physician;
  patientTrigger: PatientTrigger;
  patientSurveyTrigger: PatientSurveyTrigger;
  patientTriggerEvent: PatientTriggerEvent;
  patientTriggerSurveyName: string;
  patientTriggerSurveyCategory: SurveyCategory;
  patientSurveyId: string;
  patientSurveySessionScore: string;
  session: PatientSurveySession;
  name: string;
  comment: string;
  seenAt: Date;
  seenBy: Date;
  status: string;
}

interface PatientSurveyTriggerEventData extends JSONAPIRecord {
  relationships: {
    patient: JSONAPISingleRelationship;
    physician: JSONAPISingleRelationship;
    patient_trigger: JSONAPISingleRelationship;
    patient_survey_trigger: JSONAPISingleRelationship;
    patient_trigger_event: JSONAPISingleRelationship;
    patient_survey_session: JSONAPISingleRelationship;
  }
}

export const deserializeEvent: Deserializer<PatientSurveyTriggerEvent, PatientSurveyTriggerEventData> = (data, included) => {
  const patient = deserializeSingleRelationship<Patient>(data.relationships.patient, included, deserializePatient);
  const physician = deserializeSingleRelationship<Physician>(data.relationships.patient, included, deserializePhysician);
  const patientTrigger = deserializeSingleRelationship<PatientTrigger>(data.relationships.patient_trigger,included, deserializePatientTrigger);

  const patientSurveyTrigger = deserializeSingleRelationship<PatientSurveyTrigger>(
    data.relationships.patient_survey_trigger,included, deserializeSurveyTrigger);

  const patientTriggerEvent = deserializeSingleRelationship<PatientTriggerEvent>(
    data.relationships.patient_trigger_event, included, deserializePatientTriggerEvent);

  const session = deserializeSingleRelationship<PatientSurveySession>(
    data.relationships.patient_survey_session, included, deserializePatientSurveySession);

  return {
    ...deserializeItem(data),
    session,
    patient,
    physician,
    patientTrigger,
    patientTriggerEvent,
    patientSurveyTrigger
  };
};

export const deserializeSurveyTriggerEventWithoutTriggerEvent: Deserializer<PatientSurveyTriggerEvent, PatientSurveyTriggerEventData> = (data, included) => {
  const patient = deserializeSingleRelationship<Patient>(data.relationships.patient, included, deserializePatient);
  const physician = deserializeSingleRelationship<Physician>(data.relationships.patient, included, deserializePhysician);
  const patientTrigger = deserializeSingleRelationship<PatientTrigger>(data.relationships.patient_trigger,included, deserializePatientTrigger);

  const session = deserializeSingleRelationship<PatientSurveySession>(
    data.relationships.patient_survey_session, included, deserializePatientSurveySession);

  return {
    ...deserializeItem(data),
    session,
    patient,
    physician,
    patientTrigger
  };
};

